import { render, staticRenderFns } from "./AffiliateDashboard.vue?vue&type=template&id=4c652908"
import script from "./AffiliateDashboard.vue?vue&type=script&lang=js"
export * from "./AffiliateDashboard.vue?vue&type=script&lang=js"
import style0 from "./AffiliateDashboard.vue?vue&type=style&index=0&id=4c652908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports